// extracted by mini-css-extract-plugin
export default {"box":"style_box__JwzNf","title":"style_title__tZTsL","text":"style_text__TC33j","button":"style_button__0OhYz","link":"style_link__Mv+ox"};